/**
 * Skip links are hidden links that allow users to skip directly to specific
 * sections of a webpage (usually the main content). These are generaly
 * used by screen reader users and keyboard-only users to improve
 * navigation accessibility.
 */
import {css} from "aphrodite";
import * as React from "react";

import {a11yStyles} from "@khan/shared-styles";

interface Props {
    id?: string;
    /**
     * The CSS selector for the target element to skip to. This should
     * be a unique selector that matches the element you want focused.
     * For example, `#main` or `#[uniqueId]-lesson-content`.
     */
    targetSelector: string;
    /**
     * The (already translated) text to display for the skip link.
     * This should indicate where the link will take the user when pressed.
     */
    translatedText: string;
}

function SkipLink(props: Props): React.ReactNode {
    const {targetSelector, translatedText, ...restProps} = props;
    return (
        <a
            href={targetSelector}
            className={css(a11yStyles.skipToMain)}
            /* This onClick is here to assert focus behavior in automation */
            onClick={() =>
                document?.querySelector<HTMLElement>(targetSelector)?.focus()
            }
            {...restProps}
        >
            {translatedText}
        </a>
    );
}

export default SkipLink;
